<template>

  <v-data-table
    dense
    :headers='workedOnHeaders'
    :items='entry.worked_on_objs'
    class='grey lighten-2'
    no-data-text='No worked on details for this entry'
    hide-default-footer
    disable-sort
    disable-pagination
  >
    <template v-slot:item.category_obj="{ item }">
      <v-icon
        v-if='item.category && item.category_obj.division'
        small
        :color='item.category_obj.division_obj.icon_color'
      >{{item.category_obj.division_obj.icon}}</v-icon>
      {{ item.category ? item.category_obj.description : "" }}
    </template>

    <template v-slot:item.project_obj="{ item }">
      {{ item.project ? item.project_obj.name : "" }}
    </template>

    <template v-slot:item.detail_obj="{ item }">
      {{ item.detail ? item.detail_obj.description : "" }}
    </template>

    <template v-slot:header.actions>
      <div class='d-flex'>
        <v-btn
          v-if='entry.duplicateDate'
          x-small
          depressed
          class='mt-n1 mr-1'
          color='error'
          @click='deleteEntry()'
        >
          Delete
        </v-btn>
        <v-btn
          v-if='entry.employee_obj'
          x-small
          depressed
          class='mt-n1'
          color='info'
          @click='openEntry()'
        >
          {{ entry.duplicateDate ? "Open" : "Open Entry" }}
        </v-btn>
        <v-btn
          v-else
          x-small
          depressed
          class='mt-n1'
          color='orange'
          @click='addEntry()'
        >
          Add Entry
        </v-btn>
      </div>
    </template>
  
      <v-btn
        v-if='entry.duplicateDate'
        x-small
        depressed
        class='mt-n1'
        color='error'
        @click='deleteEntry()'
      >
        Delete Entry
      </v-btn>
 
  </v-data-table>
 
</template>

<script>
import _ from 'lodash'

export default {
  name: 'payroll-worked-ons-table',
  props: {
    entry: {
      required: true,
      type: Object
    }
  },
  data: () => ({
    workedOnHeaders: [
      { text: 'Category', value: 'category_obj', class:'subtitle-2', align: 'start' },
      { text: 'Project', value: 'project_obj', class:'subtitle-2', align: 'start' },
      { text: 'Detail', value: 'detail_obj', class:'subtitle-2', align: 'start' },
      { text: 'Notes', value: 'notes', class:'subtitle-2' },
      { text: 'Hrs/Job', value: 'num_hours', class:'subtitle-2', align: 'end', width: '80' },
      { text: '', value: 'actions', align: 'center', width: '154'}
    ],
  }),
  computed: {

  },
  methods: {
    openEntry () {
      let entryCopy = _.cloneDeep(this.entry)
      this.$emit("openEntry", entryCopy)
    },
    addEntry () {
      let entryCopy = _.cloneDeep(this.entry)
      this.$emit("addEntry", entryCopy)
    },
    deleteEntry () {
      let entryCopy = _.cloneDeep(this.entry)
      this.$emit("deleteEntry", entryCopy)
    }
  },
  components: {

  }
}

</script>